export interface SessionUpdateData {
  title?: string;
  summary?: string;
}

export const updateSession = async (sessionId: string, data: SessionUpdateData): Promise<void> => {
  try {
    const existingData = localStorage.getItem(`beehive-session-${sessionId}`);
    const sessionData = existingData ? JSON.parse(existingData) : {};
    
    const updatedData = {
      ...sessionData,
      ...data,
      updatedAt: new Date().toISOString()
    };
    
    localStorage.setItem(`beehive-session-${sessionId}`, JSON.stringify(updatedData));
    
    await new Promise(resolve => setTimeout(resolve, 100));
  } catch (error) {
    console.error('Failed to update session:', error);
    throw error;
  }
};

export const getSession = async (sessionId: string): Promise<SessionUpdateData | null> => {
  try {
    const data = localStorage.getItem(`beehive-session-${sessionId}`);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Failed to get session:', error);
    return null;
  }
};

interface SessionInitRequest {
  goal: string;
  repoUrl?: string;
  initialMessage?: string;
  rawTitle?: string;
}

interface SessionInitResponse {
  success: boolean;
  sessionId: string;
  title: string;
  plugins: string[];
  playbook?: string;
  nextQuestion?: string;
  messages?: Array<{ role: string; text: string }>;
}

export class SessionsService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_BACKEND_URL || '';
  }

  async initSession(request: SessionInitRequest): Promise<SessionInitResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/api/sessions/init`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Session init error:', error);
      
      return {
        success: true,
        sessionId: `fallback_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        title: 'New Development Task',
        plugins: ['ChatBee', 'SupervisorBee'],
        playbook: 'general-development',
        nextQuestion: undefined
      };
    }
  }
}

export const sessionsService = new SessionsService();
